import React, { useState } from "react";
import Navigation from '../Navigation'
import Logo from "../UI/Logo";

const Header = () => {
  const [open, setopen] = useState(false);
  return (
    <div className="absolute inset-x-0">
      <header className="container">
        <div className="flex flex-row items-center justify-between px-4 py-4 lg-px-0 lg:py-1">
          <Logo className="relative z-50 -ml-8" />

          <nav>
            {/* <!-- Primary Navigation Menu --> */}
            <div className="hidden lg:block ">
              <Navigation />
            </div>

            {/* <!-- Hamburger --> */}
            <div className="flex items-center -mr-2 lg:hidden">
              <button
                onClick={() => setopen((prev) => !prev)}
                className="relative z-50 inline-flex items-center justify-center p-2 text-gray-400 transition duration-150 ease-in-out rounded-md hover:text-gray-500 hover:bg-gray-100 focus:outline-none focus:bg-gray-100 focus:text-gray-500"
              >
                <svg
                  className="w-6 h-6"
                  stroke="currentColor"
                  fill="none"
                  viewBox="0 0 24 24"
                >
                  <path
                    className={`${open ? "hidden" : "inline-flex"}`}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M4 6h16M4 12h16M4 18h16"
                  />
                  <path
                    className={`${open ? "inline-flex" : "hidden"}`}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M6 18L18 6M6 6l12 12"
                  />
                </svg>
              </button>
            </div>

            {/* <!-- Responsive Navigation Menu --> */}
            <div
              className={` ${
                !open && "-translate-x-[100%]"
              } lg:hidden z-50 fixed inset-y-0 w-[60%] shadow bg-white top-0 left-0  transition-transform duration-200 ease-in delay-75`}
              id="mobile-nav"
            >
              <div className="py-8 mb-4 border-b logo border-neutral-100">
                <Logo />
              </div>
              <Navigation />
            </div>
          </nav>
        </div>
      </header>
    </div>
  );
};

export default Header;
